export default __webpack_public_path__ + "63c8795d1e6a7d03c72ffbe0a9d5c4a1.png";